import { useRef, useCallback } from 'react';

//*** function will have always correct(latest) context,
//*** and resulting function will be the same(will not recreate),
//*** so react will not rerender component, where this callback will be as input
export const useFlexibleMemoizedCallback = (clb, dependencies = []) => {
  const clbRef = useRef();
  clbRef.current = clb;
  return useCallback(function(){ clbRef.current(...arguments) }, dependencies);
};